import {createContext, useContext} from 'react';

export enum Locale {
  uk = 'en-GB',
  nl = 'nl',
  test = 'en-TEST', // for testing purposes only
}

const LocaleContext = createContext<Locale>(Locale.uk);

export function useLocale(): Locale {
  return useContext(LocaleContext);
}

export default LocaleContext;
